(() => {
  if (window.sapSiteKitLoaded) return;
  window.sapSiteKitLoaded = true;
  const shellTokens = getComputedStyle(document.documentElement);
  const tablet = matchMedia(`(min-width: ${shellTokens.getPropertyValue('--sap-shell-tablet').trim()})`);
  const desktop = matchMedia(`(min-width: ${shellTokens.getPropertyValue('--sap-shell-desktop').trim()})`);
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const setups = new Map();
  const announcements = new Map();
  const kitOwnsHeader = () => document.body.classList.contains('sap-kit-enabled');
  const syncAnnouncements = () => {
    document.querySelectorAll('[id$="__announcement-bar"] carousel-component').forEach(carousel => {
      if (!carousel.embla || !carousel.autoplay) return;
      let state = announcements.get(carousel);
      if (!state) {
        state = {suspended:false, resume:false};
        state.guard = () => { if (state.suspended && carousel.isPlay) carousel.stop(); };
        carousel.on('changePlayState', state.guard);
        announcements.set(carousel,state);
      }
      if (kitOwnsHeader()) {
        if (!state.suspended) { state.resume = carousel.isPlay; state.suspended = true; }
        if (carousel.isPlay) carousel.stop();
      } else if (state.suspended) {
        carousel.getBoundingClientRect();
        carousel.reInit();
        state.suspended = false;
        if (state.resume) carousel.play();
      }
    });
  };

  const syncBag = () => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    const head = drawer.querySelector('.cart-drawer__header');
    const empty = drawer.querySelector('[data-cart-drawer-warning]');
    for (const [target,selector,marker] of [[head,'[data-kit-bag-head]','.sap-kit-bag__wordmark'],[empty,'[data-kit-bag-empty]','.sap-kit-bag__empty']]) {
      const template = document.querySelector(selector);
      if (target && template && !target.querySelector(marker)) target.append(template.content.cloneNode(true));
    }
    const shipping = document.querySelector('[data-kit-bag-shipping]');
    if (head && shipping && !drawer.querySelector('.sap-kit-bag__shipping')) head.after(shipping.content.cloneNode(true));
    if (!drawer.hasAttribute('data-sap-kit-overlay-original')) drawer.setAttribute('data-sap-kit-overlay-original',drawer.getAttribute('data-with-overlay') ?? '');
    const overlay = kitOwnsHeader() ? 'true' : drawer.getAttribute('data-sap-kit-overlay-original');
    if (drawer.getAttribute('data-with-overlay') !== overlay) {
      if (drawer.isOpen) drawer.hide(true);
      drawer.setAttribute('data-with-overlay',overlay);
    }
  };
  const syncScroll = () => {
    const nativeBody = document.querySelector('body-element');
    const locked = nativeBody?.isFixed || document.body.classList.contains('scroll-y-off') || document.body.style.position === 'fixed';
    const effectiveScroll = locked ? Math.abs(parseFloat(document.body.style.top) || nativeBody?.fixedTopPosition || scrollY) : scrollY;
    const scrolled = effectiveScroll > 24;
    document.querySelectorAll('[data-sap-kit-header],.sap-kit-offer').forEach(node => node.classList.toggle('is-scrolled', scrolled));
  };
  let frame;
  addEventListener('scroll', () => {
    if (!frame) frame = requestAnimationFrame(() => { frame = null; syncScroll(); });
  }, {passive:true});
  const init = root => {
    root.querySelectorAll('[data-sap-kit-header]').forEach(header => {
      if (setups.has(header)) return;
      const dialog = header.querySelector('[data-kit-menu]');
      const opener = header.querySelector('[data-kit-menu-open]');
      const nav = [...header.querySelectorAll('[data-kit-nav][aria-controls]')];
      const panels = [...header.querySelectorAll('[data-kit-panel]')];
      const listeners = new AbortController();
      let leaveTimer, previousOverflow, activeNav, pointerNav, pointerWasOpen, wasKitActive = false;
      const closePanels = () => {
        clearTimeout(leaveTimer);
        panels.forEach(panel => { panel.hidden = true; });
        nav.forEach(link => link.setAttribute('aria-expanded','false'));
        activeNav = null;
        header.classList.remove('is-open');
      };
      const openPanel = link => {
        if (!desktop.matches) return;
        clearTimeout(leaveTimer);
        panels.forEach(panel => { panel.hidden = panel.dataset.kitPanel !== link.dataset.kitNav; });
        nav.forEach(item => item.setAttribute('aria-expanded',String(item === link)));
        activeNav = link;
        header.classList.add('is-open');
      };
      const closeMenu = () => { if (dialog.open) dialog.close(); };
      const on = (node,type,fn) => node.addEventListener(type,fn,{signal:listeners.signal});
      on(opener,'click',() => {
        closePanels();
        previousOverflow = document.body.style.overflow;
        dialog.querySelectorAll('details').forEach(group => { group.open = false; });
        dialog.querySelector('.sap-kit-menu__body').scrollTop = 0;
        dialog.showModal();
        opener.setAttribute('aria-expanded','true');
        document.body.style.overflow = 'hidden';
        dialog.querySelector('[data-kit-menu-close]').focus();
      });
      on(dialog.querySelector('[data-kit-menu-close]'),'click',closeMenu);
      on(dialog,'keydown',event => {
        if (event.key !== 'Tab') return;
        const controls = [...dialog.querySelectorAll('a[href],button:not([disabled]),summary')].filter(control => control.checkVisibility());
        const target = event.shiftKey && document.activeElement === controls[0] ? controls.at(-1) : !event.shiftKey && document.activeElement === controls.at(-1) ? controls[0] : null;
        if (target) { event.preventDefault(); target.focus(); }
      });
      on(document,'shopify:block:select',event => {
        const copies = [...header.querySelectorAll('[data-kit-block]')].filter(node => node.dataset.kitBlock === event.detail?.blockId);
        const target = copies.find(node => desktop.matches ? node.closest('[data-kit-panel]') : node.closest('[data-kit-menu]')) || copies[0];
        if (!target) return;
        const panel = target.closest('[data-kit-panel]');
        if (desktop.matches && panel) { closeMenu(); openPanel(nav.find(link => link.dataset.kitNav === panel.dataset.kitPanel)); }
        else { if (!dialog.open) opener.click(); const group = target.closest('details'); if (group) group.open = true; }
      });
      on(document,'shopify:block:deselect',event => {
        if ([...header.querySelectorAll('[data-kit-block]')].some(node => node.dataset.kitBlock === event.detail?.blockId)) { closePanels(); closeMenu(); }
      });
      const bagButton = header.querySelector('[data-bag-count-label]');
      const updateBagName = () => {
        const count = bagButton?.querySelector('cart-count')?.textContent.trim() || '0';
        if (bagButton) bagButton.setAttribute('aria-label',bagButton.dataset.bagCountLabel.replace('__COUNT__',count));
      };
      const countObserver = new MutationObserver(updateBagName);
      if (bagButton) countObserver.observe(bagButton,{childList:true,subtree:true,characterData:true});
      updateBagName();
      on(dialog,'close',() => {
        document.body.style.overflow = previousOverflow ?? '';
        opener.setAttribute('aria-expanded','false');
        if (opener.checkVisibility()) opener.focus({preventScroll:true});
      });
      on(dialog,'click',event => {
        const box = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) closeMenu();
      });
      nav.forEach(link => {
        on(link,'pointerenter',event => { if (event.pointerType === 'mouse') openPanel(link); });
        on(link,'pointerdown',() => { pointerNav = link; pointerWasOpen = activeNav === link; });
        // Keyboard focus alone no longer opens a panel (A11y A4): Enter (the click below), Space or Down Arrow opens it, and Tab enters only an open one.
        on(link,'focus',() => { if (pointerNav !== link && activeNav && activeNav !== link) closePanels(); });
        on(link,'keydown',event => {
          if (!desktop.matches || event.shiftKey) return;
          if (event.key === ' ') { event.preventDefault(); if (activeNav === link) closePanels(); else openPanel(link); return; }
          if (event.key !== 'ArrowDown' && !(event.key === 'Tab' && activeNav === link)) return;
          const panel = panels.find(item => item.dataset.kitPanel === link.dataset.kitNav);
          const first = panel?.querySelector('a[href],button:not([disabled])');
          if (first) { event.preventDefault(); openPanel(link); first.focus(); }
        });
        on(link,'click',event => {
          if (desktop.matches && (pointerNav === link ? !pointerWasOpen : activeNav !== link)) { event.preventDefault(); openPanel(link); }
          pointerNav = null;
        });
      });
      panels.forEach(panel => on(panel,'keydown',event => {
        if (event.key !== 'Tab') return;
        const links = [...panel.querySelectorAll('a[href],button:not([disabled])')];
        const owner = nav.find(link => link.dataset.kitNav === panel.dataset.kitPanel);
        if (event.shiftKey && event.target === links[0]) { event.preventDefault(); owner.focus(); }
        else if (!event.shiftKey && event.target === links.at(-1)) {
          event.preventDefault(); closePanels();
          const next = owner.nextElementSibling;
          if (next) next.focus(); else header.querySelector('[data-search-open]').focus();
        }
      }));
      on(document,'pointercancel',() => { pointerNav = null; });
      on(header,'mouseleave',() => { leaveTimer = setTimeout(closePanels,160); });
      on(header,'mouseenter',() => clearTimeout(leaveTimer));
      on(header,'focusout',event => { if (!header.contains(event.relatedTarget)) closePanels(); });
      on(document,'pointerdown',event => { if (!header.contains(event.target)) closePanels(); });
      on(document,'keydown',event => {
        if (event.key === 'Escape' && activeNav) {
          const focusTarget = activeNav;
          closePanels();
          focusTarget.focus();
          closePanels();
        }
      });
      on(desktop,'change',() => { closePanels(); closeMenu(); });
      const syncOwners = () => {
        syncAnnouncements();
        syncBag();
        // The old header was removed; discard saved review rollback state.
        if (document.body.classList.contains('sap-rollback-kit-header')) document.body.classList.remove('sap-rollback-kit-header');
        const kitActive = document.body.classList.contains('sap-kit-enabled');
        if (kitActive && !wasKitActive) document.querySelectorAll('drawer-menu').forEach(drawer => {
          if (drawer.isOpen && typeof drawer.hide === 'function') drawer.hide(true);
        });
        wasKitActive = kitActive;
        const oldCount = document.querySelector('[id$="__header"] cart-count');
        const newCount = header.querySelector('cart-count');
        if (oldCount) oldCount.id = kitActive ? 'SapOriginalCartCount' : 'CartCount';
        if (newCount) newCount.id = kitActive ? 'CartCount' : 'SapKitCartCount';
        syncScroll();
      };
      const rollback = new MutationObserver(syncOwners);
      rollback.observe(document.body,{attributes:true,attributeFilter:['class']});
      syncOwners();
      setups.set(header,() => {
        if (dialog.open) { closeMenu(); document.body.style.overflow = previousOverflow ?? ''; }
        clearTimeout(leaveTimer); listeners.abort(); rollback.disconnect(); countObserver.disconnect();
      });
    });
    root.querySelectorAll('[data-sap-kit-footer]').forEach(footer => {
      if (setups.has(footer)) return;
      const groups = [...footer.querySelectorAll('.sap-kit-footer__group')];
      groups.forEach(group => {
        const summary = group.querySelector('summary');
        const heading = document.createElement('h3');
        heading.className = summary.className + ' sap-kit-footer__group-title';
        heading.textContent = summary.textContent;
        heading.hidden = true;
        summary.after(heading);
      });
      const sync = () => groups.forEach((group,index) => {
        group.open = tablet.matches || (!footer.classList.contains('sap-kit-footer--3') && index===0);
        const summary = group.querySelector('summary');
        summary.tabIndex = tablet.matches ? -1 : 0;
        summary.hidden = tablet.matches;
        group.querySelector('.sap-kit-footer__group-title').hidden = !tablet.matches;
      });
      const keepOpen = event => {
        const summary = event.target.closest('.sap-kit-footer__group > summary');
        if (tablet.matches && summary) event.preventDefault();
      };
      sync(); tablet.addEventListener('change', sync); footer.addEventListener('click',keepOpen);
      setups.set(footer, () => { tablet.removeEventListener('change',sync); footer.removeEventListener('click',keepOpen); });
    });
    root.querySelectorAll('[data-kit-motion-toggle]').forEach(button => {
      if (setups.has(button)) return;
      const toggle = () => { const paused = button.getAttribute('aria-pressed') !== 'true'; button.setAttribute('aria-pressed',String(paused)); button.closest('[data-kit-motion-region]').classList.toggle('is-paused',paused); };
      button.addEventListener('click',toggle);
      setups.set(button,()=>button.removeEventListener('click',toggle));
    });
    root.querySelectorAll('[data-sap-kit-announcement]').forEach(bar => {
      if (setups.has(bar)) return;
      const messages = [...bar.querySelectorAll('[data-message]')];
      let index=0;
      let timer;
      const rotate = () => {
        if (!desktop.matches || motion.matches || document.hidden || bar.classList.contains('is-paused') || bar.matches(':hover, :focus-visible, :has(:focus-visible)') || messages.length<2) return;
        messages[index].classList.remove('is-current');
        index=(index+1)%messages.length;
        messages[index].classList.add('is-current');
      };
      const syncTimer = () => {
        clearInterval(timer);
        if (desktop.matches) timer=setInterval(rotate,5000);
      };
      syncTimer();
      desktop.addEventListener('change',syncTimer);
      setups.set(bar,()=>{ clearInterval(timer); desktop.removeEventListener('change',syncTimer); });
    });
    root.querySelectorAll('[data-kit-offer-close]').forEach(button => {
      if (setups.has(button)) return;
      const close = () => { button.closest('.sap-kit-offer').hidden = true; };
      button.addEventListener('click',close);
      setups.set(button,()=>button.removeEventListener('click',close));
    });
    syncScroll();
  };
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>init(document),{once:true});
  else init(document);
  const headerSections = () => [...document.querySelectorAll('.sap-kit-header-group > .shopify-section')];
  const measure = () => {
    const height = headerSections().filter(node => node.checkVisibility()).reduce((sum,node) => sum + (node.querySelector('[data-sap-kit-header]') || node).getBoundingClientRect().height,0);
    document.documentElement.style.setProperty('--sap-kit-header-height',`${height}px`);
  };
  // Native hash jumps can start before the tall header finishes shrinking.
  // Let the browser own history, then align once against the settled header.
  let anchorTimer;
  const settleAnchor = () => {
    clearTimeout(anchorTimer);
    if (!kitOwnsHeader() || !location.hash) return;
    let target;
    try { target = document.getElementById(decodeURIComponent(location.hash.slice(1))); } catch { return; }
    if (!target?.closest('main')) return;
    anchorTimer = setTimeout(() => {
      if (!kitOwnsHeader() || !target.isConnected) return;
      syncScroll(); measure();
      target.scrollIntoView({block:'start',behavior:'instant'});
    }, 350);
  };
  addEventListener('hashchange', settleAnchor);
  addEventListener('load', settleAnchor, {once:true});
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const url = new URL(link.href, location.href);
    if (url.origin === location.origin && url.pathname === location.pathname && url.search === location.search && url.hash) requestAnimationFrame(settleAnchor);
  });
  for (const type of ['wheel','touchstart','keydown']) addEventListener(type, () => clearTimeout(anchorTimer), {passive:true});
  const resize = new ResizeObserver(measure);
  const watchHeaders = () => { resize.disconnect(); headerSections().forEach(node => resize.observe(node.querySelector('[data-sap-kit-header]') || node)); measure(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',watchHeaders,{once:true});
  else watchHeaders();
  let watchedBag, bagObserver;
  const watchBag = event => {
    const drawer = document.querySelector('cart-drawer');
    if (drawer !== watchedBag) {
      bagObserver?.disconnect(); watchedBag = drawer;
      if (drawer) { bagObserver = new MutationObserver(syncBag); bagObserver.observe(drawer,{childList:true,subtree:true}); }
    }
    if (event?.target.querySelector('[data-kit-bag-empty]')) drawer?.querySelectorAll('.sap-kit-bag__wordmark,.sap-kit-bag__empty,.sap-kit-bag__shipping').forEach(node=>node.remove());
    syncBag();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',watchBag,{once:true});
  else watchBag();
  document.addEventListener('shopify:section:load',watchBag);
  customElements.whenDefined('carousel-component').then(() => {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',syncAnnouncements,{once:true});
    else syncAnnouncements();
  });
  document.addEventListener('shopify:section:load',syncAnnouncements);
  document.addEventListener('shopify:section:load',watchHeaders);
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('shopify:section:unload',event=>{
    if (watchedBag && event.target.contains(watchedBag)) { bagObserver.disconnect(); watchedBag = null; }
    for (const [carousel,state] of announcements) if (event.target.contains(carousel)) {
      carousel.stop(); carousel.off('changePlayState',state.guard); announcements.delete(carousel);
    }
    for (const [node,cleanup] of setups) if (event.target.contains(node)) { cleanup(); setups.delete(node); }
  });
})();
